export default __webpack_public_path__ + "static/media/panel9.2a78f6dc.jpg";